import React from "react";
import { Navigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

export function logout() {
  localStorage.clear();
  window.location.href = "/";
}

export function getcurrentToken() {
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    return "empty token";
  } else {
    return auth.token;
  }
}

export function CheckUserType() {
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    logout();
  }

  const decodedToken = jwt_decode(auth.token);
  const current_time = parseInt(+new Date() / 1000);
  if (decodedToken.exp < current_time) {
    logout();
  }

  return decodedToken.user_type;
}

export function AdminAuth(props) {
  const Cmp = props.cmp;
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    logout();
  }
  const decodedToken = jwt_decode(auth.token);
  const current_time = parseInt(+new Date() / 1000);
  if (decodedToken.exp < current_time) {
    logout();
  }

  if (decodedToken.user_type !== 1) {
    logout();
  }

  return <div>{auth ? <Cmp /> : <Navigate to="../login"></Navigate>}</div>;
}

export function UserAuth(props) {
  const Cmp = props.cmp;
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    logout();
  }
  const decodedToken = jwt_decode(auth.token);
  const current_time = parseInt(+new Date() / 1000);
  if (decodedToken.exp < current_time) {
    logout();
  }

  if (decodedToken.user_type === 1) {
    logout();
  }

  return <div>{auth ? <Cmp /> : <Navigate to="../login"></Navigate>}</div>;
}
//Sub admin auth
export function SubAdminAuth(props) {
  const Cmp = props.cmp;
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    logout();
  }
  const decodedToken = jwt_decode(auth.token);
  const current_time = parseInt(+new Date() / 1000);
  if (decodedToken.exp < current_time) {
    logout();
  }

  if (decodedToken.user_type !== 4) {
    logout();
  }

  return <div>{auth ? <Cmp /> : <Navigate to="../login"></Navigate>}</div>;
}

//Quality Superviser auth
export function QualitySupervisorAuth(props) {
  const Cmp = props.cmp;
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    logout();
  }
  const decodedToken = jwt_decode(auth.token);
  const current_time = parseInt(+new Date() / 1000);
  if (decodedToken.exp < current_time) {
    logout();
  }

  if (decodedToken.user_type !== 5) {
    logout();
  }

  return <div>{auth ? <Cmp /> : <Navigate to="../login"></Navigate>}</div>;
}

export function Remining_TokenValidity() {
  let auth = JSON.parse(localStorage.getItem("login"));
  if (auth === null) {
    return 0; //"token does not exists";
  } else {
    const decodedToken = jwt_decode(auth.token);
    const current_time = parseInt(+new Date() / 1000);
    const remaining_time = decodedToken.exp - current_time;
    return remaining_time;
  }
}
